/**
 * What one unit costs for the way it's being bought. Every product can be
 * bought once (its shelf price) or put on repeat (its subscription rate, which
 * falls back to the shelf price when the catalogue has no special rate).
 */
export function unitPrice(product, repeat) {
  if (!product) return 0;
  if (!repeat) return product.price ?? 0;
  return product.subscription_price ?? product.subscriptionPrice ?? product.price ?? 0;
}

/** Per-unit saving a repeat order earns over buying once (never negative). */
export function repeatSaving(product) {
  return Math.max(0, (product?.price ?? 0) - unitPrice(product, true));
}

/** A friendly cadence name for a plan, from its weekdays. */
export function cadenceLabel(plan) {
  if (!plan) return 'On repeat';
  if (plan.is_custom ?? plan.isCustom) return 'Days you pick';
  const days = new Set(plan.delivery_weekdays ?? plan.deliveryWeekdays ?? []);
  if (days.size === 7) return 'Every day';
  if (days.size === 5 && [1, 2, 3, 4, 5].every((d) => days.has(d))) return 'Weekdays';
  return plan.name;
}

/** The plan to preselect when a shopper first switches to repeat. */
export function defaultPlan(plans = []) {
  const fixed = plans.filter((p) => !(p.is_custom ?? p.isCustom));
  return (
    fixed.find((p) => (p.delivery_weekdays ?? p.deliveryWeekdays ?? []).length === 5) ??
    fixed[0] ??
    plans[0] ??
    null
  );
}
